export default "__VITE_ASSET__8c3e2878__"